import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { useDragLayer } from 'react-dnd';
import { usePreview } from 'react-dnd-preview';
// Import UI Components
import { Checkbox, Icon } from '@geneui/components';
// Import Components
import FilterDependencyDots, { DependencyPill, FilterInfoPopover } from 'components/common/FilterDependencyDots';
// Import Styles
import styles from './Row.module.scss';

const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '48%',
    height: '100%',
};

const PreviewRow = () => {
    const previewCollect = usePreview();
    const collect = useDragLayer((monitor) => {
        return {
            item: monitor.getItem(),
            itemType: monitor.getItemType(),
            initialOffset: monitor.getInitialSourceClientOffset(),
            currentOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging(),
        };
    });

    if (!previewCollect.display) {
        return null;
    }
    if (!collect.isDragging) {
        return null;
    }

    function getItemStyles(initialOffset, currentOffset, defaultTranslateX = 0, defaultTranslateY = 0) {
        if (!initialOffset || !currentOffset) {
            return {
                display: 'none',
            };
        }
        const { x, y } = currentOffset;
        const transform = `translate(${x - defaultTranslateX}px, ${y - defaultTranslateY}px)`;

        return {
            transform,
            WebkitTransform: transform,
        };
    }

    const { name, description, schemaDeps = [], hasInfoTooltip } = collect.item;
    const hasDependencies = schemaDeps.length > 0;
    const hasDescription = hasInfoTooltip && !isEmpty(description);
    const infoTitle = typeof name === 'string' || typeof name === 'number' ? String(name) : '';

    return (
        <>
            <div style={{ ...layerStyles, ...collect.item?.style }}>
                <div
                    className={classNames('d-a-d-item-draggable', {
                        'permanent-row': collect.item.isPermanent,
                    })}
                    style={getItemStyles(collect.initialOffset, collect.currentOffset)}
                >
                    <div className={classNames('d-a-d-item-label-part', styles.rowLabelPart)}>
                        {collect.item.withSelect && <Checkbox checked={collect.item.isChecked} />}
                        <span>{name}</span>
                    </div>

                    <div className={styles.rowActions}>
                        {(hasDependencies || hasDescription) && (
                            <DependencyPill>
                                {hasDependencies && <FilterDependencyDots schemaDeps={schemaDeps} isDragging />}
                                {hasDescription && (
                                    <FilterInfoPopover title={infoTitle} description={description} isDragging />
                                )}
                            </DependencyPill>
                        )}
                        <Icon type="bc-icon-drag" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default PreviewRow;
